




















































import TableComp from '@/components/Common/TableComp.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getGearStepListApi } from '@/api/index';
import { UserModule } from '@/store/modules/user';

@Component({
  name: 'studentCourseApplyList',
  components: {
    TableComp,
  }
})
export default class extends Vue {
  @Prop({ default: () => [] }) public tableData!: any[];

  public stepOptions: any[] = [];

  get stepNameIndex() {
    return (stepKey: string) => {
      const options = this.stepOptions;
      if (options.length) {
        return (options.findIndex((item) => Number(stepKey) === item.id))
      }
    }
  }

  public mounted() {
    this.getStepList();
  }

  public mediaAndAttached(fileList: any) {
    if (fileList && fileList.length > 0) {
      return fileList.map((item: any) => item.typeKey).join(',');
    }
    return '';
  }

  public editStudentCourse() {
    const stuid = this.$route.params.id + '';
    const agentId = UserModule.fkAgentId;
    this.$router.push({ name: 'studentApplicationForm', params: { stuid }, query: { agid: agentId, activeNames: 'applicationSch' }});
  }

  public async getStepList() {
    const { data } = await getGearStepListApi();
    this.stepOptions = data.datas;
  }

  public handleRowClick({ row }: { row: any, column: any}) {
    this.$emit('row-click', row);
  }
}
